export default __webpack_public_path__ + "static/media/miguel-lopes-39.7f6c15e4.jpg";